import React from "react";
import { Dismissible } from "MODULES/shared/containers";

export default function dismissible(Comp) {
  class DismissibleComponent extends Dismissible {
    render() {
      const { show: _, ...rest } = this.props;

      return (
        <div
          style={{ display: "inline" }}
          ref={node => {
            this.content = node;
          }}
        >
          <Comp
            visible={this.state.visible}
            open={this.open}
            close={this.close}
            toggle={this.toggle}
            {...rest}
          />
        </div>
      );
    }
  }

  return DismissibleComponent;
}

export function dismissibleChild(Comp) {
  class DismissibleChild extends Dismissible {
    render() {
      const { show: _, ...rest } = this.props;

      return (
        <Comp
          visible={this.state.visible}
          open={this.open}
          close={this.close}
          toggle={this.toggle}
          contentRef={node => {
            this.content = node;
          }}
          {...rest}
        />
      );
    }
  }

  return DismissibleChild;
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/dismissible.jsx